import 'css-chunksrc/client/scenes/workloads/wbs/milestone/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_1i5om_1",
  "input": "_input_1i5om_5",
  "readOnly": "_readOnly_1i5om_12",
  "disabled": "_disabled_1i5om_18"
};